import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fixed top-0 left-0 z-10 w-full backdrop-blur-md bg-white/30" }
const _hoisted_2 = { class: "container mx-auto px-4 h-20 flex items-center justify-between" }
const _hoisted_3 = { class: "relative group" }
const _hoisted_4 = { class: "absolute inset-y-0 left-0 flex items-center pl-4 group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  name: "search",
  id: "search",
  autocomplete: "given-name",
  placeholder: "Search",
  class: "block h-10 pl-12 text-sm transition duration-300 border-gray-200 rounded-full w-80 bg-background border-1 focus:outline-none"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xs font-bold uppercase tracking-wider" }, " Whitelabel Market ", -1)
const _hoisted_7 = { class: "flex items-center justify-start space-x-4 w-80" }
const _hoisted_8 = { class: "basis-10" }
const _hoisted_9 = { class: "basis-10" }
const _hoisted_10 = { class: "grow" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "block slashed-zero" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "block" }, " Connect Wallet ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_AppLogoIcon = _resolveComponent("AppLogoIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CogIcon = _resolveComponent("CogIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BellIcon = _resolveComponent("BellIcon")!
  const _component_CreditCardIcon = _resolveComponent("CreditCardIcon")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "start", {}, () => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_SearchIcon, { class: "w-4 h-4 text-gray-500" })
            ]),
            _hoisted_5
          ])
        ]),
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              class: "flex flex-col items-center space-y-0.5",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AppLogoIcon, { class: "h-8" }),
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]),
        _renderSlot(_ctx.$slots, "end", {}, () => [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_AppButton, {
                color: "white",
                size: "sm",
                onlyIcon: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CogIcon, { class: "w-4 h-4" })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_AppButton, {
                color: "white",
                size: "sm",
                onlyIcon: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BellIcon, { class: "w-4 h-4" })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_AppButton, {
                color: "white",
                size: "sm",
                fullWidth: "",
                to: { path: '/connect' }
              }, {
                default: _withCtx(() => [
                  (_ctx.wallet.isConnected.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("img", {
                          src: _ctx.wallet.avatarUri.value,
                          alt: _ctx.wallet.address.value,
                          class: "w-5 h-5 object-cover rounded-full overflow-hidden"
                        }, null, 8, _hoisted_11),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.wallet.privateAddress.value), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_CreditCardIcon, { class: "w-4 h-4" }),
                        _hoisted_13
                      ], 64))
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}